/*
Author: Dan Miller
Date: 1/29/15
This directive is designed to disable ngAnimate on individual directives. There is a
known bug as of AnuglarJS version 1.3.5 and Angular-UI 0.4.0 with the 
Anuglar - UI Carousel that causes unwanted behavior if ngAnimate is enabled.
Adding this attribute to the markup will fix the issue and allow the carousel
to function properly.
*/

/// <reference path="../app.ts" />
namespace Cfnc {
    "use strict";

    interface IDisableAnimation extends ng.IDirective {

    }

    interface IDisableAnimationScope extends ng.IScope {

    }

    class DisableAnimation implements IDisableAnimation {
        static directiveId: string = "disableAnimation";
        restrict: string = "A";

        constructor(private $animate) {
        }

        link = ($scope: IDisableAnimationScope, element, attrs) =>{
            attrs.$observe("disableAnimation",(value) => {
                this.$animate.enabled(!value);
            });
        }

    }

    angular.module("app").directive(DisableAnimation.directiveId, ["$animate", ($animate) =>
        new DisableAnimation($animate)
    ]);

}